import React from "react";
import { Inbox, CheckCircle2, XCircle } from "lucide-react";

export const CandidaturasList = ({ applications, onDecide }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-hidden mb-6">
    <div className="p-4 border-b border-slate-200 flex items-center gap-2">
      <Inbox className="w-5 h-5 text-slate-500" />
      <h2 className="font-display font-bold text-lg text-[#0B2B62]">Candidaturas ({applications.length})</h2>
    </div>
    {applications.length === 0 ? (
      <div className="p-10 text-center text-slate-500 text-sm">Nenhuma candidatura recebida ainda.</div>
    ) : (
      <div className="divide-y divide-slate-100">
        {applications.map((a) => (
          <div key={a.id} data-testid={`app-${a.id}`} className="p-4 hover:bg-slate-50">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className={`text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full ${a.type === "consultor" ? "bg-indigo-100 text-indigo-800" : a.type === "profissional" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>{a.type === "consultor" ? "Consultor" : a.type === "profissional" ? "Profissional" : "Unidade Parceira"}</span>
                  <span className={`text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full ${a.status === "pending" ? "bg-slate-200 text-slate-700" : a.status === "approved" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>{a.status}</span>
                  <h3 className="font-display font-semibold text-[#0B2B62]">{a.name}</h3>
                </div>
                <div className="text-xs text-slate-500 mt-1">{a.email} · {a.phone}</div>
                {a.clinic_data && (
                  <div className="text-xs text-slate-600 mt-1">
                    {a.clinic_data.city}/{a.clinic_data.state} · {a.clinic_data.beds || 0} vaga(s) · {(a.clinic_data.modality || []).join(", ") || "modalidade não informada"}
                  </div>
                )}
                <p className="text-sm text-slate-700 mt-2 whitespace-pre-line">{a.message}</p>
                {a.decision_notes && <div className="text-xs text-slate-500 mt-1 italic">Nota: {a.decision_notes}</div>}
              </div>
              {a.status === "pending" && (
                <div className="flex gap-2 shrink-0">
                  <button data-testid={`app-approve-${a.id}`} onClick={() => onDecide(a.id, "approve")}
                    className="px-3 py-1.5 bg-green-600 text-white rounded-md text-xs font-semibold hover:bg-green-700 inline-flex items-center gap-1">
                    <CheckCircle2 className="w-3.5 h-3.5" /> Aprovar
                  </button>
                  <button data-testid={`app-reject-${a.id}`} onClick={() => onDecide(a.id, "reject")}
                    className="px-3 py-1.5 border border-red-500 text-red-600 rounded-md text-xs font-semibold hover:bg-red-50 inline-flex items-center gap-1">
                    <XCircle className="w-3.5 h-3.5" /> Rejeitar
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default CandidaturasList;
